import type { HTMLAttributes, ReactNode } from 'react';

interface DarkCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  active?: boolean;
}

export default function DarkCard({
  children,
  active = false,
  className = '',
  ...rest
}: DarkCardProps) {
  return (
    <div
      className={`rounded-3xl bg-white p-6 shadow-lg dark:bg-surface ${
        active
          ? 'border-2 border-amber shadow-glow-amber'
          : 'border border-gray-200 dark:border-white/5'
      } ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
